import { render, staticRenderFns } from "./input-coa-key.vue?vue&type=template&id=1f98f764"
import script from "./input-coa-key.vue?vue&type=script&lang=js"
export * from "./input-coa-key.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@coac/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports